import {createContext, useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import axiosConfig from "../components/utils/axiosConfig";
import {fetchPartner, notify} from "../components/utils/utils";

const AuthContext = createContext();

const AuthProvider = ({children}) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")) || "");
    const [token, setToken] = useState(JSON.parse(localStorage.getItem("token")) || "");
    const navigate = useNavigate();


    const loginAction = async (data) => {
            try {
                const res = await axiosConfig.post(`/auth/user/login`, data);
                if (res.data) {
                    // check if the domain matches the logged user otherwise redirect to the right domain
                    fetchPartner(res.data?.user?.Kundennummer).then((response) => {
                        if (window.location.hostname !== response?.domain) {
                            notify("Domain stimmt nicht mit dem angemeldeten Benutzer überein. Sie werden auf die korrekte Domain weitergeleitet.")
                            window.setTimeout(function () {
                                window.location.href = `https://${response?.domain}/login`;
                            }, 5000);
                        } else {
                            //console.log(res.data.user)
                            setUser(res.data.user);
                            setToken(res.data.authorization.token);
                            localStorage.setItem("user", JSON.stringify(res.data.user));
                            localStorage.setItem("token", JSON.stringify(res.data.authorization.token));
                            navigate("/dashboard");
                            window.location.reload();
                        }
                    });
                } else {
                    notify("Zugriff verweigert bitte wenden Sie sich an den Administrator")
                    navigate("/login");
                    //window.location.reload();
                }
            } catch
                (err) {
                notify("Zugriff verweigert bitte wenden Sie sich an den Administrator")
                navigate("/login");
                //window.location.reload();
                //console.error(err);
            }
        }
    ;

    const logOut = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        navigate("/login");
        //window.location.reload();
    };

    return (
        <AuthContext.Provider value={{token, user, loginAction, logOut}}>
            {children}
        </AuthContext.Provider>
    );

};

export default AuthProvider;

export const useAuth = () => {
    return useContext(AuthContext);
};